import React, { useEffect } from 'react'
import { Link, useOutletContext, useSearchParams, Navigate } from 'react-router-dom';
import Loading from '../loading/Loading';

function Auth() {
    const [searchParams] = useSearchParams();
    const params = Object.fromEntries([...searchParams]);
    const { rut: cliente } = useOutletContext();
useEffect(()=>{
        localStorage.setItem("t",params?.t);
        localStorage.setItem("user", JSON.stringify({ w : params?.w, r : cliente, n : params?.n, rd: params?.rd}));
        window.location.href = "/web/bandeja"
},[]);
  return (
    <Loading />
   /*  <Navigate
      to="/web/bandeja"
      replace = {false}
      state= {{ rut : cliente, w : params?.w} }
    /> */
  )
}

export default Auth